import { render, staticRenderFns } from "./DestinationJumbo.vue?vue&type=template&id=2b843840&"
import script from "./DestinationJumbo.vue?vue&type=script&lang=ts&"
export * from "./DestinationJumbo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports